var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "inactivityModal",
        "content-class": "menu-bg-blue-transparent-modal",
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "hide-header": "",
        "hide-footer": "",
      },
    },
    [
      _c("span", { staticStyle: { "font-size": "150%" } }, [
        _vm._v(
          "\n    Your session will expire in " +
            _vm._s(this.timeBeforeLogout) +
            " seconds.\n    Interact with this page to remain logged in.\n  "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }